import { SaTravelRequestSnapshot } from '@/components/Approval/@components/SaTravelExpense/SaTravelRequest';
import { parseSaTravelExpenseContent } from '@/utils/approval/saTravelExpense';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 179 SA 신규 출장비 사전 신청 — 저장 content 그대로(레거시 조회와 동일) */
const SaTravelRequestSlot = ({ data }: ContentExtraProps) => {
  const content = parseSaTravelExpenseContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SaTravelRequestSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SaTravelRequestSlot;
